import { zefDialogOpen, zefDialogClose } from '@zerops/zef/dialog';
import { FEATURE_NAME } from './service-ui-overlay.constant';
import { ServiceUiOverlayMeta } from './service-ui-overlay.model';

export const serviceUiOverlayOpen = (meta: ServiceUiOverlayMeta) =>
  zefDialogOpen({ key: FEATURE_NAME, meta });

export const serviceUiOverlayClose = () =>
  zefDialogClose({ key: FEATURE_NAME });
